let getState: any = null;
import("Store").then((module) => {
  getState = module.store.getState;
});

declare global {
  interface Window {
    prayntStayte: any;
    efs_debug: any;
    efs_verbosity: any;
    log: any;
  }
}

function prayntStayte(slicePreference = null) {
  if (slicePreference) console.log(getState()[slicePreference]);
  else console.log(getState());
}
// THREE LEVELS OF VERBOSITY FOR LOG DEBUGGING
// 2 highest level
// 1 medium level
// 0 default
function log(toPrint: any, verbosity: number = 0) {
  if (!window.efs_debug) return;
  if (window.efs_verbosity === 2) console.log(toPrint);
  else if (window.efs_verbosity === 1 && verbosity <= 1) console.log(toPrint);
  else if (window.efs_verbosity === 0 && verbosity === 0) console.log(toPrint);
}

export function setUpDev() {
  window.efs_debug =
    process.env.NODE_ENV !== "production" ||
    process.env.REACT_APP_EFS_DEBUG === "true";
  window.efs_verbosity = 0;
  window.log = log;
  window.prayntStayte = prayntStayte;
}

export const testDummyData = process.env.NODE_ENV !== "production" && false;
export const testDummyDataPeepNumber = 40;
export const testDummyMedia = process.env.NODE_ENV !== "production" && false;
export const testDontConnectToRoom =
  process.env.NODE_ENV !== "production" && true;
